<template>
  <div class="template-add-edit-page2">
    <!-- hearder -->
    <div class="template-header-menus">
      <div class="menu-btn" title="Ctrl+Enter" @click="onRunCode">
        <CaretRightFilled />
        <span>{{$t("Common_Excute")}}</span>
      </div>
      <div class="menu-btn" @click="onSaveTemplate">
        <SaveFilled />
        <span>{{$t("TP_Edit_2_Top_Button2")}}</span>
      </div>
      <div class="reservation-menu">
        <div class="reservation-btn">
          <div class="info-item">{{$t("TP_Edit_2_Top_Info1")}}</div>
          <div class="info-text">{{$t("TP_Edit_2_Top_Info2")}}</div>
        </div>
        <div class="reservation-modal">
          <div class="reservation-header">
            <div>{{$t("TP_Edit_2_Reservation_Head1")}}</div>
            <div>{{$t("TP_Edit_2_Reservation_Head2")}}</div>
            <div>{{$t("TP_Edit_2_Reservation_Head3")}}</div>
          </div>
          <div
            v-for="(item, index) in reservationList"
            :key="index"
            class="reservation-content"
          >
            <div class="title">{{ item.title }}</div>
            <div class="reservation">{{ item.reservation }}</div>
            <div class="type">{{ item.type }}</div>
          </div>
          <div class="reservation-example">
            ex)
            <div>
              {{$t("TP_Edit_2_Reservation_Ex2")}}{{ "${TARGET_NAME}$" }}{{$t("TP_Edit_2_Reservation_Ex3")}}
            </div>
            <div v-if="isPhishing">
              {{$t("TP_Edit_2_Reservation_Ex4")}}{{`${next}`}}{{$t("TP_Edit_2_Reservation_Ex5")}}
              <!-- {{`링크 설정: <a href="${next}" target="_blank">휴대폰 인증</a>`}} -->
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- contents -->
    <div class="template-page2-body" @keydown.ctrl.13="onRunCode">
      <TemplateSidebar
        :mode="mode"
        :templateInfo="templateInfo"
        :templateNo="templateNo"
        :images="images"
        :getImages="getImages"
        :isPublic="isPublic"
        :screenEnable="screenEnable"
        :phishingLevel="phishingLevel"
        :currentIndex="currentIndex"
        :onSelectValue="onSelectValue"
        :handlePhishingLevel="handlePhishingLevel"
        :handleCurrentIndex="handleCurrentIndex"
        :isPhishing="isPhishing"
      />
      <div class="template-page2-content">
        <!-- mailbody, step1, step2 -->
        <div
          class="editor-item"
          :class="{ show: index === currentIndex && currentIndex !== 3 }"
          v-for="(item, index) in templates"
          :key="index"
        >
          <CodemirrorEditor
            v-if="index === currentIndex && currentIndex !== 3"
            :index="index"
            :data="templates[index]"
            :currentIndex="currentIndex"
            :previewStatus="previewStatus"
            :onChangeCodemirror="onChangeCodemirror"
            :isPhishing="isPhishing"
          />
        </div>

        <!-- result -->
        <div
          class="editor-item"
          :class="{ show: currentIndex === 3 && screenEnable === 1 }"
        >
          <CodemirrorEditor
            v-if="currentIndex === 3 && screenEnable === 1"
            :index="3"
            :key="3"
            :data="templateResult"
            :currentIndex="currentIndex"
            :previewStatus="previewStatus"
            :onChangeCodemirror="onChangeCodemirror"
            :isPhishing="isPhishing"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {
  computed,
  onMounted,
  reactive,
  toRefs,
  ref,
  watch,
  watchEffect,
} from "vue";
import { useStore } from "vuex";
import { CaretRightFilled, SaveFilled } from "@ant-design/icons-vue";
import axios from "axios";
import { apiUrl } from "@/utils/common";
import TemplateSidebar from "@/components/sideComponents/TemplateSidebar";
import CodemirrorEditor from "@/components/sideComponents/CodemirrorEditor";
import { useI18n } from "vue-i18n";

export default {
  name: "TemplateEditPage2",
  props: {
    mode: String,
    templateInfo: Object,

    templateNo: Number,
    images: Array,
    getImages: Function,
    deleteImages: Function,
    saveInputValue: Function,
    currentPage: Number,
    toggleModal: Function,
  },
  components: {
    TemplateSidebar,
    CodemirrorEditor,
    CaretRightFilled,
    SaveFilled,
  },
  setup(props) {
    const store = useStore();
    const { t } = useI18n();
    const templateInputValues = computed(
      () => store.getters["template/GET_INPUT_VALUES"]
    );

    const editMode = props.mode === "edit" ? true : false;
    const {
      isPublic,
      templatePublic,
      isEnable,
      screenEnable,
      phishingLevel,
      currentIndex,
      templates,
      templateResult,
      imageList,
      examType,
    } = templateInputValues.value;

    const state = reactive({
      currentIndex: 0,
      previewStatus: "off",
      previewItem: {},
      isPhishing: examType === 4,
    });

    const formState = reactive({
      isPublic: isPublic,
      screenEnable: screenEnable,
      phishingLevel: phishingLevel,
      templatePublic: templatePublic,
      isEnable: isEnable,
      templates: templates,
      templateResult: templateResult,
    });

    const next = "${STAGE_NEXT}$";
    const reservationList = computed(() => {
      const result = [
        {
          title: t("TP_Edit_2_Reservation_list1"),
          reservation: "${TARGET_NAME}$",
          type: t("TP_Edit_2_Reservation_list2"),
        },
        {
          title: t("TP_Edit_2_Reservation_list3"),
          reservation: "${TARGET_EMAIL}$",
         type: t("TP_Edit_2_Reservation_list2"),
        },
        {
          title: t("TP_Edit_2_Reservation_list4"),
          reservation: "${TARGET_ID}$",
          type: t("TP_Edit_2_Reservation_list2"),
        },
        {
          title: t("TP_Edit_2_Reservation_list5"),
          reservation: "${TARGET_PHONE}$",
          type: t("TP_Edit_2_Reservation_list2"),
        },
        {
          title: t("TP_Edit_2_Reservation_list6"),
          reservation: "${TARGET_DIVISION}$",
          type: t("TP_Edit_2_Reservation_list2"),
        },
        {
          title: t("TP_Edit_2_Reservation_list7"),
          reservation: "${TARGET_POSITION}$",
          type: t("TP_Edit_2_Reservation_list2"),
        },
      ];

      if (state.isPhishing) {
        result.push(
          {
            title: t("TP_Edit_2_phishing1"),
            reservation: "${STAGE_NEXT}$",
            type: t("TP_Edit_2_phishing4"),
          },
          {
            title: t("TP_Edit_2_phishing2"),
            reservation: "${STAGE_FINISH}$",
            type: t("TP_Edit_2_phishing4"),
          }
        );
      } else {
        result.push({
          title: t("TP_Edit_2_phishing3"),
          reservation: "${LINK_TEXT}$",
          type: t("TP_Edit_2_phishing4"),
        });
      }
      return result;
    });

    // 버튼, 드롭다운 선택 이벤트
    const onSelectValue = (name, value) => {
      formState[name] = value;

      // 선택 값 스토어에 저장
      props.saveInputValue({ [name]: value });

      // 결과 화면 사용 여부 변경 시 메일 본문이 선택되도록
      if (name === "screenEnable") {
        state["currentIndex"] = 0;
        state["previewStatus"] = "off";
      }
    };

    // 페이지 선택 이벤트
    const handleCurrentIndex = (index) => {
      if (state.currentIndex === index) return;

      state["currentIndex"] = index;
      state["previewStatus"] = "off";
    };

    // 피싱 단계 설정 이벤트
    const handlePhishingLevel = (type) => {
      // 피싱 단계 증가
      if (type === "increase") {
        const { phishingLevel } = formState;
        if (phishingLevel === 3) return;
        formState["phishingLevel"] = phishingLevel + 1;
        formState["templates"].push({
          html: "",
          js: "",
          css: "",
        });
      }
      // 피싱 단계 감소
      else if (type === "decrease") {
        const { phishingLevel, currentIndex, templates } = formState;
        if (phishingLevel === 1) return;
        formState["phishingLevel"] = phishingLevel - 1;
        formState["templates"] = templates.slice(0, -1);
        if (currentIndex + 1 >= phishingLevel) {
          formState["currentIndex"] = currentIndex === 3 ? 3 : currentIndex - 1;
        }
      }
      props.saveInputValue({
        phishingLevel: formState["phishingLevel"],
        templates: formState["templates"],
      });
    };

    // 에디터 편집 시 이벤트
    const onChangeCodemirror = (type, currentIndex, value) => {
      const { templateResult, templates } = formState;
      //currentIndex -> 0: 메일 본문, 1: 단계1, 2: 단계2, 3: 결과 화면
      if (currentIndex === 3) {
        formState["templateResult"] = { ...templateResult, [type]: value };
      } else {
        formState["templates"][currentIndex] = {
          ...templates[currentIndex],
          [type]: value,
        };
      }
      props.saveInputValue({
        templates: formState["templates"],
        templateResult: formState["templateResult"],
      });
    };

    // 미리보기 url
    const makePreviewUrl = ({ html, css, js }) => {
      const parseCode = (code) => {
        if (code) {
          const date = new Date();
          const month = date.getMonth();
          const doubleDigitMonth = month < 10 ? "0" + month : month;

          return code
            .replace(/\$\{SERVER_ROOT\}\$/g, window.location.origin)
            .replace(/\$\{DATE_YM\}\$/g, date.getFullYear() + doubleDigitMonth);
        } else {
          return "";
        }
      };

      const parsedHTML = parseCode(html);
      const parsedCSS = parseCode(css);
      const parsedJS = parseCode(js);
      const source = ` <html>
        <head>
          <style>${parsedCSS}</style>
        </head>
        <body>
          ${parsedHTML}
          fscript src="${window.location.origin}/certification/jquery/jquery-1.10.2.min.js"><lscript
          fscript>${parsedJS}<lscript
        </body>
      </html>`
        .replace(/fscript/g, "<script")
        .replace(/lscript/g, "/script>");

      let iframeDoc = document.getElementById(
        `custom-template ${state.previewStatus}`
      ).contentWindow.document;
      iframeDoc.open();
      iframeDoc.write(source);
      iframeDoc.close();
    };

    // 실행 버튼 이벤트
    const onRunCode = () => {
      const { currentIndex } = state;
      const { templates, templateResult } = formState;

      makePreviewUrl({
        html:
          currentIndex === 3
            ? templateResult.html
            : templates[currentIndex].html,
        css:
          currentIndex === 3 ? templateResult.css : templates[currentIndex].css,
        js: currentIndex === 3 ? templateResult.js : templates[currentIndex].js,
      });

      state["previewItem"] = templates[currentIndex];
      state["previewStatus"] = "on";
    };

    // 저장 버튼 이벤트
    const onSaveTemplate = async () => {
      const {
        templateNo,
        mode,
        uploadedList,
        images,
        deleteImages,
        templateInfo,
      } = props;

      try {
        // 등록
        if (mode === "add") {
          const origin = uploadedList;
          const current = images;
          deleteImages(origin, current, current, 1);
        }
        // 수정
        else if (mode === "edit") {
          const origin = templateInfo.imageList;
          const current = images;
          deleteImages(origin, current, current, 1);
        }

        const {
          templateName,
          autoUpdate,
          templatePublic,
          category,
          language,
          isEnable,
          examType,
          subject,
          sendName,
          sendEmail,
          screenEnable,
          phishingLevel,
          isPublic,
          templates,
          templateResult,
        } = templateInputValues.value;

        const isPhishing = examType === 4 ? true : false;

        const params = {
          templateNo,
          templateName,
          autoUpdate,
          templatePublic,
          category,
          language,
          isEnable,
          examType,
          subject,
          sendName,
          sendEmail,

          body: templates[0] ? templates[0].html : "",
          phishingHtml1: templates[1] && isPhishing ? templates[1].html : "",
          phishingCss1: templates[1] && isPhishing ? templates[1].css : "",
          phishingJs1: templates[1] && isPhishing ? templates[1].js : "",
          phishingHtml2: templates[2] && isPhishing ? templates[2].html : "",
          phishingCss2: templates[2] && isPhishing ? templates[2].css : "",
          phishingJs2: templates[2] && isPhishing ? templates[2].js : "",
          resultScreenHtml:
            templateResult.html && screenEnable ? templateResult.html : "",
          resultScreenCss:
            templateResult.css && screenEnable ? templateResult.css : "",
          resultScreenJs:
            templateResult.js && screenEnable ? templateResult.js : "",
          isPublic,
          screenEnable,
          phishingLevel,
        };

        const response = await axios.put(apiUrl + "Template", params);
        if (response && !response.data.error) {
          // commit
          store.dispatch("template/UPDATE_TEMPLATE", response);
        }
      } catch (error) {
        console.log("saveTemplate error", error);
      }

      props.toggleModal(props.mode);
    };

    return {
      ...toRefs(state),
      ...toRefs(formState),
      onSelectValue,
      handleCurrentIndex,
      handlePhishingLevel,
      onChangeCodemirror,
      onRunCode,
      reservationList,
      onSaveTemplate,
      next,
      // editors,
    };
  },
};
</script>